import SageScreen from "kit/SageScreen";
import React from "react";
import { useSelector } from "react-redux";
import accessTokenSelector from "selectors/accessToken";

const DesktopLogin: React.FC = () => {
    const accessToken = useSelector(accessTokenSelector);

    return (
        <SageScreen>
            <h2>Login on Desktop</h2>
            <p>
                Hit the below button to log in on your desktop version of Rend A
                Hand. You need to make sure that you have Rend A Hand installed
                on Mac OS or Windows.
            </p>
            <a
                className="btn btn-primary"
                href={`rendahand://login?access_token=${accessToken}`}
            >
                Open
            </a>
        </SageScreen>
    );
};

export default DesktopLogin;
